import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../../services/api/axiosConfig';
import AuthLayout from '../../../layouts/AuthLayout';
import { Alert } from 'flowbite-react';
import { Link } from 'react-router-dom';

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const [status, setStatus] = useState('verifying');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        document.title = "Account verification";
        const abortController = new AbortController();
        let isMounted = true;

        const verify = async () => {
            const token = params.get('token');

            if (!token) {
                if (isMounted) {
                    setStatus('error');
                    setErrorMessage('Verification link is incomplete. Missing token.');
                }
                return;
            }

            try {
                const res = await api.post(
                    '/verify-email',
                    { token },
                    { signal: abortController.signal }
                );

                if (isMounted) {
                    if (res.data.success === true) {
                        setStatus('success');
                    } else {
                        setStatus('error');
                        setErrorMessage('Verification failed . Invalid link or already expired');
                    }
                }
            } catch (err) {
                if (isMounted) {
                    setStatus('error');
                    setErrorMessage('Verification failed . Invalid link or already expired');

                }
            }
        };

        verify();

        return () => {
            isMounted = false;
            abortController.abort();
        };
    }, [params]);


    // Render different messages based on the verification status
    return (
        <AuthLayout title="Account verification">

            <div>
                {status === 'verifying' && (
                    <>
                        <h2>Verifying Your Email...</h2>
                        <p>Please wait, this may take a moment.</p>
                    </>
                )}

                {status === 'success' && (
                    <div style={{ color: '#28a745', border: '1px solid #28a745', padding: '15px', borderRadius: '5px', backgroundColor: '#e2f0e6' }}>
                        <h2>Email Verified!</h2>
                        <p>Your email address has been successfully verified.</p>
                        <p>You can now log in to your account.</p>
                    </div>
                )}


                {status === 'error' && (
                    <Alert color="failure" onDismiss={() => setErrorMessage('')} className="mb-4">
                        <span className="font-medium"></span> {errorMessage}
                    </Alert>
                )}



            </div>



            <div className="mt-8">
                <p className="text-sm text-center mt-4">
                    <Link to='/' className="font-medium  hover:underline ">
                        Login
                    </Link>
                </p>
            </div>

        </AuthLayout>

    );
}